export default __webpack_public_path__ + "static/media/down_arrow.1b57139f.svg";